import React from "react";
import './ProgressBar.css';


export function ProgressBar() {
    return <div className="progress-container">
                <div className="progress-materializecss">
                    <div className="indeterminate"></div>
                </div>
            </div>
}
